import { preloadImage } from '@99designs/design-services-common';
import { getDesignProductPresenters } from './productsPresenter';
import type { SupportedLocale } from '@99designs/i18n';

export const getPopularDesignSearchProducts = (locale: SupportedLocale) => {
    const products = getDesignProductPresenters(locale);
    return [
        products.standardBusinessCards,
        products.productBoxes,
        products.classicCottonToteBagSmall,
    ].map((product) => {
        const searchPreviewImage = product.searchPreviewImage({
            cloudinaryOptions: { width: 100 },
        })?.url;
        if (searchPreviewImage) {
            preloadImage(searchPreviewImage);
        }
        return {
            designProductPresenter: product,
            matches: [
                {
                    key: 'translatedTitle',
                    value: product.translatedTitle(),
                    indices: [],
                },
            ],
        };
    });
};
